<script setup>
definePage({
  meta: {
    layout: 'blank',
    action: 'manage',
    subject: 'Setting',
  },
})

// Module 21 (§7 `2.0.4`) — pages/administration/settings/index.vue sekarang
// jadi halaman Pengaturan sungguhan. File ini TIDAK dihapus (meski isinya
// cuma redirect) karena route name 'settings-tab' masih dirujuk
// NavbarShortcuts.vue (layouts/components, "mostly do not modify" per
// CLAUDE.md) — sama pola persis dashboards/analytics.vue (Module 20).
const router = useRouter()

onMounted(() => router.replace({ name: 'administration-settings' }))
</script>

<template>
  <div />
</template>
